<template>
    <div class="qCardWrapper">

        <div :class="['itemBox' ,'clear',content.view==100?'noMargin':'']">
            <div class="content">
<!--                <Question :text="content.tips" v-if="content.right"/>-->

                    <div class="textBoxW" v-if="!content.right">
                        <View0 v-if="content.view===0" :tips="content.tips"></View0>
                        <View9 v-if="content.view==1" :list="content.list" :tips="content.tips"  :buttonType="content.buttonType"
                               @on-action="onBtnAction"/>
                        <View4 v-if="content.view===2" :list="content.list" :tips="content.tips"/>
                        <View5 v-if="content.view===4" :list="content.list" :tips="content.tips"
                               @on-router="onNavigate"/>
                        <View11 v-if="content.view===5" :list="content.list" :tips="content.tips" @on-ask="onRequest"/>
                        <View7 v-if="content.view===6" :list="content.list" :tips="content.tips"
                               @on-ask="onRequest"/>
                        <View8 v-if="content.view===7" :list="content.list" :tips="content.tips"
                               @on-router="onNavigate"/>
                        <View12 v-if="content.view==8" :list="content.list" :tips="content.tips"
                                @on-more="onMoreComment"/>
                        <View10 v-if="content.view==9" :list="content.list" :tips="content.tips"
                                @on-action="onBtnAction"  buttonType="hasBg"/>
                        <View6 v-if="content.view==10" :list="content.list" :tips="content.tips"
                               @on-router="onNavigate"/>
                        <View2 v-if="content.view==11" :list="content.list" :tips="content.tips"/>
<!--                        <View3  v-if="content.view===12" :tips="content.tips"/>-->
                        <View9 v-if="content.view==12" :list="content.list" :tips="content.tips"  buttonType="noBg"
                               @on-action="onBtnAction"/>
                        <View13  v-if="content.view===13" :tips="content.tips"  :list="content.list"/>
                        <View14 v-if="content.view==14" :list="content.list" :tips="content.tips" :other="content"
                                @on-process="onMultiProgress"/>
                        <View15 v-if="content.view==15" :list="content.list" :tips="content.tips"
                                @on-show="onShowNews"/>
                        <View9 v-if="content.view==16" :list="content.list" :tips="content.tips"
                               @on-action="onBtnAction" buttonType="noBg"/>
                        <View16 v-if="content.view==17" :list="content.list" :tips="content.tips"
                                @on-ask="onTourDetails" />
                        <View17 v-if="content.view==18" :list="content.list" :tips="content.tips"/>
                        <View18 v-if="content.view==19" :list="content.list" :tips="content.tips"/>
                        <View10 v-if="content.view==20" :list="content.list" :tips="content.tips"
                                @on-action="onBtnAction" buttonType="hasBg"/>
                    </div>
                </div>

        </div>

    </div>
</template>
<script>
    import {
        View1,
        View2,
        View3,
        View6,
        Question,
        View0,
        View8,
        View7,
        View4,
        View5,
        View11,
        View12,
        View9,
        View10,
        View14,
        View15,
        View13,
        View16,
        View17,View18
    } from "./View/index";
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "QCard",
        components: {
            View1,
            View2,
            View3,
            View6,
            Question,
            View0,
            View8,
            View7,
            View5,
            View11,
            View4,
            View12,
            View9,
            View10,
            View14,
            View15,
            View13,
            View16,
            View17,View18
        },
        props: {
            content: {
                type: Object,
                default: {}
            }
        },
        computed: {
            ...mapState(["chatLoading", "readNewsId", "device"])
        },
        data() {
            return {};
        },
        methods: {

            ...mapMutations([
                "contactDisData", "setHomeData", "setToastList", "setLinkSrc", "setGlobalDuration", "setChatLoading", "setLinkSrc", "setClearTimer", "setReadNewsId", "setOpenChat", "setInputShow","setTagsList","setToastContent","setToastShow"
            ]),
            ...mapActions(["fetchRelate", "fetchHome", "fetchHomeNoData","queryComment", "discussNewsOther", "getHotTopic", "getHotTopicDesc", "getHotTopicNews", "getHotNews", "getSceneCommon", "queryMultiProgress","getSceneMultiProcess","getTourData","getWantToInfo","getTourInfo","getTourCommon"]),
            /*type:0（预设） 1（H5） 2（多流程） 3（测评）*/
            onNavigate(link, id, isCurrent, type, title, except, exceptValue) {
                let that=this;
                if(except===1){
                    this.fetchHomeNoData({payload: {question: exceptValue}}).then((res) => {that.onTypeHandle(link, id, isCurrent, type, title)});
                }
                else{
                    this.onTypeHandle(link, id, isCurrent, type, title)
                }
                this.setClearTimer(true);
            },

            onTypeHandle(link, id, isCurrent, type, title){
                if (isCurrent) {
                    this.setLinkSrc(link);


                    this.$router.push({
                        path: "/blank"
                    });
                } else {
                    switch (type) {
                        case 0: {
                            // window.location.href = link;
                            this.fetchHome({payload: {question: title}}).then((res) => {
                                if (res.length) {
                                    this.setChatLoading(false);
                                }
                                setTimeout(() => {
                                    this.service.pageScrollTo();
                                }, 600);
                                //cio.track(7, "click", 'send_msg',{msg: value});
                            });

                        }
                            break;
                        case 1: {
                            window.location.href = link;
                        }
                            break;
                        case 2: {
                            this.onMultiProgress("", "", "", id);
                        }
                            break;
                        case 3: {
                            this.onMultiProgress("", "", "", id);
                        }
                            break;
                        default: {
                            //todo
                        }
                            break;
                    }

                }
            },

            onMultiProgress(name, optionId, value, sceneId, nodeId, sessionId) {
                let that = this;
                this.setChatLoading(true);
                this.setGlobalDuration(0);
                this.contactDisData([{content: {right: true, tips: name}}]);
                this.queryMultiProgress({
                    payload: {
                        question: value,
                        nodeId,
                        sceneId,
                        sessionId,
                        optionId
                    }
                }).then((res) => {
                    if (res.length) {that.setChatLoading(false);}
                    setTimeout(() => {that.service.pageScrollTo();}, 100);
                });
            },

            onRequest(name, value) {
                let that = this;
                this.setChatLoading(true);

                this.setGlobalDuration(0);
                that.contactDisData([{content: {right: true, tips: name}}]);
                that.fetchHome({payload: {question: value}}).then((res) => {
                    if (res.length) {
                        that.setChatLoading(false);
                    }
                    setTimeout(() => {
                        that.service.pageScrollTo();
                    }, 600);
                    cio.track(7, "click", 'send_msg',{msg: value});
                });

            },

            onMoreComment() {
                this.queryComment({payload: {newsId: this.readNewsId}});
            },

            onTourDetails(name,id){
                let that = this;
                this.setChatLoading(true);
                this.setGlobalDuration(0);
                this.contactDisData([{content: {right: true, tips: `小封小封，我想去${name}`}}]);
                this.getTourInfo({payload: {id}}).then((res) => {
                    if (res.length) {that.setChatLoading(false);}
                    setTimeout(() => {that.service.pageScrollTo();}, 100);
                });
            },

            onBtnAction(type, id, tips, value,sessionId) {
                let that = this;
                this.setChatLoading(true);

                switch (type) {
                    case 0: {
                        //聊新闻
                        // this.contactDisData([{content: {right: true, tips: value}}]);
                        this.contactDisData([{content: {view: 100, tips: value}}]);
                        this.setInputShow(true);
                        this.setOpenChat(true);
                        this.setChatLoading(false);
                        that.$nextTick(() => {
                            that.service.onInputBlur();
                        }, 1000);

                    }
                        break;
                    case 1: {
                        //返回全网新闻 不想看了 不感兴趣
                        this.setInputShow(true);
                        this.contactDisData([{content: {right: true, tips}}]);
                        this.getHotNews().then((res) => {
                            this.setReadNewsId("");
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 2: {
                        //返回其他新闻
                        this.contactDisData([{content: {right: true, tips}}]);
                        this.discussNewsOther({payload: {id: id}}).then((res) => {
                            this.setReadNewsId("");
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });


                    }
                        break;
                    case 3: {
                        //继续查看当前新闻的其他评论
                        that.contactDisData([{content: {right: true, tips}}]);
                        this.queryComment({payload: {newsId: this.readNewsId}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 4: {
                        //热点新闻  了解
                        that.contactDisData([{content: {right: true, tips}}]);
                        this.getHotTopicNews({payload: {id: id}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 5: {
                        //热点新闻  不了解
                        that.contactDisData([{content: {right: true, tips}}]);
                        this.getHotTopicDesc({payload: {id: id}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 6: {
                        // 不感兴趣
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getSceneCommon({payload: {}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 7: {
                        //我想看看
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.fetchHome({payload: {question: '聊新闻'}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    case 8: {
                        //流程对话 再玩一次
                        that.onMultiProgress(tips, "", "", id);
                    }
                        break;
                    case 9: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getSceneMultiProcess({payload: {}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    /*旅游推荐 不感兴趣*/
                    case 10: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getTourCommon().then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;

                    /*旅游推荐 */
                    case 11: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getTourData({payload:{}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });

                    }
                        break;
                    /*旅游推荐 换一批*/

                    case 12: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getTourData({payload: {}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    /*旅游  我想去这里玩*/
                    case 13: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getWantToInfo({payload: {id}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    //移动 推荐 知道
                    case 14: {
                        that.setChatLoading(false);
                        window.location.href = 'https://m.thecover.cn/subject.html?id=4244&channel_type=30';
                    }
                        break;
                    //移动 推荐 不知道  //旅游的接口  //新闻换一批
                    case 15: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.fetchHome({payload: {question:value}}).then((res) => {
                            if (res.length) {that.setChatLoading(false);}
                            setTimeout(() => {that.service.pageScrollTo();}, 100);
                        });
                    }
                        break;
                    /*旅游  看看其他景点 radioType:16*/
                    case 16: {
                        that.contactDisData([{content: {right: true, tips}}]);
                        that.getTourData({payload: {}}).then((res) => {
                            if (res.length) {
                                that.setChatLoading(false);
                            }
                            setTimeout(() => {
                                that.service.pageScrollTo();
                            }, 300);
                        });
                    }
                        break;
                    default:
                        break;
                }
            },


            onShowNews(id,info){
                console.info('info',info)
                this.setToastShow(true);
                this.setReadNewsId(id);
                this.setToastContent({toastType: 7, list: {name: "", content: info}});
            }
        }
    };
</script>
<style lang="less">
    .clear {
        clear: both;

    }




    .qCardWrapper {
        .itemBox {
            width: 8.25rem;
            color: #313035;
            display: flex;
            /*justify-content: flex-start;*/
            margin: .12rem .4rem .5rem .4rem;
        }

        .noMargin {
            margin: 0 !important;
        }



        .content {
            /*padding: 0rem .15rem;*/

            min-width: 2rem;
            border-radius: .15rem;

            .textBox {
                width: 100%;
                height: 100%;

                word-break: break-all;
            }
        }

        .marginCls {
            margin-bottom: .2rem;
        }


        .borderTop {
            border-top: 1px solid #ff0006;
        }
    }
</style>
